import React from 'react';
import ArrowForwardIcon from '@material-ui/icons/ArrowForwardIos';
import { API_STATUS, ApiStatusDisplayType } from '../../types';
import {
  StyledCard,
  ImageContainer,
  CardImage,
  CardTitle,
  CardDescription,
  CardBody,
  CardActions,
  ActionButton,
  StyledChip,
  CardSubtitle,
  CardTitleWrapper,
  BadgeWrapper,
  StatusBadge,
} from './ApiCard.styles';

export interface ApiCardProps {
  image?: string;
  title?: string;
  productType?: string;
  description?: string;
  subtitle?: string;
  price?: string | number;
  buttonLabel?: string;
  onActionClick?: () => void;
  isNew: boolean;
  isDeprecated: boolean;
}

function getDisplayBadge(
  isNewStatus: boolean,
  isDeprecatedStatus: boolean,
): ApiStatusDisplayType {
  if (isDeprecatedStatus) return API_STATUS.DEPRECATED;
  if (isNewStatus) return API_STATUS.NEW;
  return null;
}

const ApiCard: React.FC<ApiCardProps> = ({
  image = '',
  title = '',
  productType = '',
  description = '',
  subtitle = '',
  buttonLabel = 'Get More Info',
  onActionClick,
  isNew,
  isDeprecated,
}) => {
  const displayBadge = getDisplayBadge(isNew, isDeprecated);

  return (
    <StyledCard>
      <ImageContainer>
        <CardImage src={image} alt={title || 'Product Preview'} />
        {displayBadge && (
          <BadgeWrapper>
            <StatusBadge>{displayBadge}</StatusBadge>
          </BadgeWrapper>
        )}
      </ImageContainer>

      <CardBody>
        <CardTitleWrapper>
          <CardTitle title={title} variant="h6">
            {title}
          </CardTitle>
          {subtitle && <CardSubtitle title={subtitle}>{subtitle}</CardSubtitle>}
        </CardTitleWrapper>
        {productType && (
          <div>
            <StyledChip label={productType} color="primary" size="small" />
          </div>
        )}
        {description && (
          <CardDescription title={description}>{description}</CardDescription>
        )}
      </CardBody>

      <CardActions>
        <ActionButton
          disableRipple
          endIcon={<ArrowForwardIcon />}
          variant="text"
          onClick={onActionClick}
        >
          {buttonLabel}
        </ActionButton>
      </CardActions>
    </StyledCard>
  );
};

export default ApiCard;
